<template>
  <div class="chat-talk">
    <div v-wechat-title="agoraRoom?agoraRoom.exhibitor.company.nameEn:'Chatroom-User'" ></div>
    <div class="chat" ref="chat">
      <!--  v-if="loading"  -->
      <div class="f-tac loading" v-if="loading" >
        <img src="@assets/img/new/icon-loading.png" />
        loading...
      </div>
      <div class="chat_wrap" id="chat_wrap">
        <div class="chat_item" v-for="item in barrageList" :key="item.id">
          <!-- .user 蓝色 .service 白色  -->
          <template v-if="item.messageType=='text'">
            <div class="txt_right user"  v-if="item.isUser">
              <div class="txt" v-html="item.message.content"></div>
              <img
                class="logo"
                :src="agoraRoom.member.avatarUrl"
                
                v-if="agoraRoom.member.avatarUrl"
              />
              <span class="flag-icon my-flag-icon logo" v-else-if="agoraRoom.member.flagStyle" :class="'flag-icon-'+agoraRoom.member.flagStyle"></span>
            </div>
            <div class="txt_left service " v-else>
              <img
                class="logo"
                :src="agoraRoom.exhibitor.company.logo"
                
              />
              <div class="txt" v-html="item.message.content"></div>
            </div>
          </template>
          <div class="txt_left room service"  v-if="item.messageType == 'url'">
            <img
              class="logo"
              :src="agoraRoom.exhibitor.company.logo"
              
            />
            <div class="txt room_info" @click.stop="joinVideoRoom(item)">
              <img :src="item.message.logo"  />
              <div class="comp_info">
                <p class="info_title">Video chat room</p>
                <p class="info_txt">
                  {{item.message.summary}}
                </p>
              </div>
            </div>
            
          </div>
          <div class="time" v-if="item.messageType == 'time'">
            {{ item.timeText }}
          </div>
          <div class="video_apply"  v-if="item.messageType=='request'">
            <p>The request has been sent. Please wait a moment...</p>
          </div>
          <div class="video_apply" v-if="item.messageType == 'roomClose'">
            <p>Sorry, the video chat room is closed</p>
          </div>
        </div>
      </div>
    </div>

    <div class="chat_bottom">
      <div
        class="newBarrage"
        v-if="newBarrageList.length > 0"
        @click="getNewBarrage"
      >
        <i class="iconfont icon-qipao"><span>{{ newBarrageList.length }}</span></i>
      </div>
      <div class="video_conn" @click="videoApplyClick" v-if="isVideoConn">
        <i class="iconfont icon-video_on"></i>
        <span>video call</span>
      </div>
      <div class="video_conn v_conn_close"  v-else>
        <i class="iconfont icon-video_on"></i>
        <span>video call</span>
      </div>
      <div class="input_con">
        <van-field
          class="input_focus"
          v-model="con"
          center
          clearable
          @keyup.enter.native="send"
          placeholder="Please enter the content"
          placeholder-class="input_place"
          @focus='inputFocus'
          type="text"
          ref="barInput"
        >
        </van-field>
        <!-- <input
          type="text"
          placeholder="Please enter the content"
          :adjust-position="false"
          cursor-spacing="13"
          v-model="con"
          @focus="inputFocus"
          ref="input"
          maxlength="500"
          @keyup.13="send()"
        /> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Bscroll from "better-scroll";
import AgoraRTM from 'agora-rtm-sdk'
import moment from "moment";
import dateString from '../../assets/js/dateString'
export default {
  name: "chat-talk",
  components: {},
  data() {
    return {
      scroll: null,
      isBottom: true,
      isTouch: false,
      isrefresh: false,
      barrageList: [], //接受留言列表
      newBarrageList: [],
      isVideoConn: false,
      pageIndex:1,
      pageSize:10,
      finished:false,
      loading:false,
      con: "",
      client:null,
      agoraRoom:null,
      logState:'',  //2小时内连线记录 not 没有 has 有
      isInform:false,
      showVideoBtn: true,
      timer: null,
    };
  },
  created() {
    this.$toast.loading('Loading');
    this.getAgoraRoom();
  },
  mounted() {
    this.initSwiper();
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
    userId(){
      return this.$route.query.userId
    },
    exhibitorId(){
      return this.$route.query.exhibitorId
    },
    msgQuery(){
      return `
        query($query:QueryInput!){
          agoraMessageQuery{
            query(query:$query){
              hasNextPage
              indexFrom
              totalCount
              pageIndex
              items{
                createAt
                exhibitorId
                id
                message
                messageType
                publisherId
                state
                stateAt
                userId
              }
            }
          }
        }`
    }
  },
  beforeDestroy(){
    this.client.logout();
  },
  methods: {
    ...mapActions({
      getMessageToken:'talk/getMessageToken',
      addAgoraMessage:'talk/addAgoraMessage',
      agoraNotify:'talk/agoraNotify',
      graphqlPost: "en/CNgraphqlPostByZXS",
      LinkVideoTalk:'linkTo/LinkVideoTalk',
      readExhibitorMsg:'talk/readExhibitorMsg'
    }),
    
    //获取聊天室
    async getAgoraRoom(){
      let query=`
        query{
          agoraQuery{
            by(exhibitorId:"${this.exhibitorId}",userId:"${this.userId}"){
              id
              member{
                avatarUrl
                userId
                name
                nickName
                flagStyle
              }
              exhibitor{
                company{
                  name
                  logo
                  nameEn
                }
              }
            }
          }
        }
      `
      let opt={
        query:query,
        variables:{},
      }
      let data=await this.graphqlPost(opt);
      let res=JSON.parse(JSON.stringify(data.data.agoraQuery.by));
      if(!res.id){
        this.$toast.fail('There is an error in the chat room, please re-enter')
        return 
      }
      this.agoraRoom=res;
      // let query1=`
      //   query{
      //     agoraQuery{
      //       isLog(agoraId:"${this.agoraRoom.id}")
      //     }
      //   }
      // `
      // let opt1={
      //   query:query1,
      //   variables:{},
      // }
      // let data1=await this.graphqlPost(opt1);
      // let res1=JSON.parse(JSON.stringify(data1.data.agoraQuery.isLog));
      // this.logState=res1;
      // console.log(this.logState,'lotW5Q5w')
      this.getMssage(true);
    },
    //获取消息记录
    async getMssage(isCreate=false){
      let where = {
        Equal: {
          n: "userId",
          v: this.userInfo.userId,
        },
        EqualA: {
          n: "exhibitorId",
          v: this.exhibitorId,
        },
      };
      let order = [
        {
          N: "createAt",
          v: 0,
        },
      ];
      let opt={
        query:this.msgQuery,
        variables: {
          query: {
            page: this.pageIndex,
            size: this.pageSize,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          }
        },
      }
      let data=await this.graphqlPost(opt);
      let res=JSON.parse(JSON.stringify(data.data.agoraMessageQuery.query));
      // console.log(data.data.agoraMessageQuery.query,'resss');
      res.items.reverse();
      res.items.forEach(el => {
        el.message=JSON.parse(el.message)
        el.isUser=el.publisherId==el.userId;
        el.timeStr=dateString.getDataString(moment(el.createAt).format('x'),true)
        // let time=moment().from(el.createAt);
        // // let nowTime=moment(new Date()).diff(el.createAt,'minute');
        // let timeMoment=moment(el.createAt).calendar(moment(), {
        //     sameDay: 'HH:mm',
        //     lastDay: '[昨天] HH:mm',
        //     lastWeek: '[上周]dd',
        //     sameElse: 'YYYY/MM/DD',
        //     // sameElse:(now)=>{
        //     //   console.log(now,'其他时间')
        //     // }
        // });
        // el.timeStr=timeMoment;
      });
      this.setRead();
      let arr=this.addDateList(res.items);
      this.barrageList=[...arr,...this.barrageList];
      console.log(this.barrageList,'ssss')
      if(isCreate){
        this.$toast.clear();
        this.initClinet();
        this.$nextTick(()=>{
          this.getNewBarrage();
        })
      }else{
        this.loading=false;
        this.scroll.finishPullDown();
        this.$nextTick(()=>{
          this.scroll.refresh();
        })
      }
      if (!res.hasNextPage) {
        this.finished = true;
      }
      
    },
    //进行时间添加
    addDateList(barrageList){
      let arr=[];
      // console.log(barrageList,'barrList')
      for (let i = 0; i < barrageList.length; i++) {
        let e=barrageList[i];
        let e1=barrageList[i+1];
        
        // console.log(e,e1,i,'e1e1e1')
        if(e.messageType=='time'){
          arr.push(e);
          continue
        }
        if(i == 0){
          let mode={
            timeText:e.timeStr,
            messageType:'time',
            id:this.getUUId()
          }
          arr.push(mode);
        }
        if(e1){
          let min=Math.abs(moment(e.createAt).diff(e1.createAt,'minute'));
          console.log(min,e.createAt,e1.createAt,'miniminin')
          if(min>=10){
            let mode={
              timeText:e1.timeStr,
              messageType:'time',
              id:this.getUUId()
            }
            arr.push(e);
            if(i != 1){
              arr.push(mode);
            }
            continue
          }
        }
        // else{
        //   e1=barrageList[i-1];
        //   console.log(e,e1,i,'最后一个');
        //   let min=Math.abs(moment(e.createAt).diff(e1.createAt,'minute'));
        //   if(min>=10){
        //     let mode={
        //       timeText:e.timeStr,
        //       messageType:'time'
        //     }
        //     // arr.push(mode);
        //     arr.push(e);
        //     continue
        //   }
        // }
        arr.push(e);
        // console.log(barrageList[i].createAt,'createAt');
      }
      // this.barrageList=JSON.parse(JSON.stringify(arr));
      // console.log(arr,'arrrrr')
      return arr
    },
    //初始化链接
    async initClinet(){
      //要token db992c4127c6454f9229216503d3e839         不要token    d805985473ad41d99c13d7adb6aa5648
      this.client=AgoraRTM.createInstance('db992c4127c6454f9229216503d3e839');
      let opt={
        channelName:this.userId,   //频道名称
        userId:'',
        privileges:[1000]
      }
      let token=await this.getMessageToken(opt) //获取token
      console.log(token,'token','gooo')
      this.monitor();
      this.client.login({ token:token, uid:this.userId}).then(()=>{
        console.log('登陆成功')
        this.client.subscribePeersOnlineStatus([this.agoraRoom.id]).then(()=>{
          console.log('订阅成功')
        }).catch(err=>{
          console.log(err,'订阅失败')
        })
      }).catch(err=>{
        this.$toast.fail('Login Error')
        console.log(err,'登陆失败')
      })
    },
    monitor(){
      this.client.on('ConnectionStateChanged', (newState, reason) => {
        console.log('状态：'+newState+'; 原因：'+reason);
      });
      this.client.on('MessageFromPeer', ({ text }, peerId) => {
        if(text){
          text=JSON.parse(text);
          if(text.exhibitorId==this.exhibitorId){
            text.message=JSON.parse(text.message);
            text.isUser=false;
            if(text.state=='unread'){
              this.setRead();
            }
            this.dataPush(text)
          }
        }
        // text 为消息文本，peerId 是消息发送方 User ID
        console.log(text,'客服得消息接收')
        console.log(peerId,'发送方id-客服')
        /* 收到点对点消息的处理逻辑 */
      });
      this.client.on('PeersOnlineStatusChanged',(status)=>{
        if(status[this.agoraRoom.id]=='ONLINE'){
          this.isVideoConn=true;
        }else{
          this.isVideoConn=false;
        }
      })
    },
    //加入视频洽谈间
    joinVideoRoom(item){
      //判断发起人-发起客服是否还在聊天室-->聊天室是否关闭 关闭push提示 没关闭进入
      if(item.state!='expire'){
        let opt={
          msgId:item.id,
          agoraId:this.agoraRoom.id,
          type:'user',
        }
        this.LinkVideoTalk(opt)
      }else{
        let opt={
          publisherId:this.userId,
          exhibitorId:this.exhibitorId,
          userId:this.userId,
          messageType:'roomClose',
          message:'',
          createAt:moment().format('YYYY/MM/DD HH:mm:ss')
        }
        //提示不用存入数据库
        this.dataPush(opt);
      }
    },
    downTime(){
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showVideoBtn = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showVideoBtn = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    //视频连线点击
    async videoApplyClick(){
      if(!this.showVideoBtn){
        this.$toast.fail('You can only send a video chat call once a minute');
        return
      }
      let msgRequst={
        type:'videoConn',             //请求类型
        text:'Applies for video chat'   //文字（动态不用传，如用户名等）
      }
      let req={
        publisherId:this.userId,
        exhibitorId:this.exhibitorId,
        userId:this.userId,
        messageType:'request',
        message:JSON.stringify(msgRequst),
      }
      let res=await this.addAgoraMessage(req);
      let opt=req;
      if(res&&res.result){
        opt=JSON.parse(JSON.stringify(res.data))  
        this.downTime();      
        //发送成功
      }else{
        this.$toast.fail('Failed to send');
      };
      this.client.sendMessageToPeer(
          { text: JSON.stringify(opt) }, // 符合 RtmMessage 接口的参数对象
          this.agoraRoom.id, // 远端用户 ID
      ).then(sendResult=> {
        //发送成功->往接口里面发数据
        // console.log(sendResult,'sendR');
        opt.message=JSON.parse(opt.message);
        opt.isUser=false;
        this.dataPush(opt)
        
        if (sendResult.hasPeerReceived) {
          /* 远端用户收到消息的处理逻辑 说明在线 */
        } else {
          /* 服务器已接收、但远端用户不可达的处理逻辑 离线 */
        }
      }).catch(error => {
        this.$toast.fail('The link has been disconnected. Sending failed');
        console.log(error,'发送失败')
        /* 发送失败的处理逻辑 */
      });
    },
    //input 获焦
    inputFocus() {},
    //发送
    async send() {
      let str=JSON.parse(JSON.stringify(this.con)) ;
      if (!this.con) {
        return;
      }else if(!str.replace(/ /g,"")){
        this.$toast.fail('Sending blank messages is not allowed');
        return 
      }
      let req={
        publisherId:this.userId,
        exhibitorId:this.exhibitorId,
        userId:this.userId,
        messageType:'text',
        message:JSON.stringify({content:this.con}),
      }
      let res=await this.addAgoraMessage(req);
      let opt=req;
      if(res&&res.result){
        opt=JSON.parse(JSON.stringify(res.data))        
        // console.log(this.isInform,this.logState,'sssssss')
        // if(!this.isInform&&this.logState=='not'){
        //   let op={
        //     exhibitorId:this.exhibitorId,
        //     userId:this.userId,
        //     langVersion:'en'
        //   }
        //   let res=await this.agoraNotify(op);
        //   console.log(res,'ressss')
        //   if(res&&res.result){
        //     this.isInform=true;
        //   }
        // }
        this.con='';
        //发送成功
      }else{
        this.$toast.fail(res.message=='今日洽谈次数已用完'?'You have reached the maximum number of chats':res.message||'Failed to send');
        return 
      };
      this.client.sendMessageToPeer(
          { text: JSON.stringify(opt) }, // 符合 RtmMessage 接口的参数对象
          this.agoraRoom.id, // 远端用户 ID
      ).then(sendResult=> {
        //发送成功->往接口里面发数据
        opt.message=JSON.parse(opt.message);
        opt.isUser=true;
        this.dataPush(opt)
        if (sendResult.hasPeerReceived) {
          /* 远端用户收到消息的处理逻辑 说明在线 */
        } else {
          /* 服务器已接收、但远端用户不可达的处理逻辑 离线 */
        }
      }).catch(error => {
        this.$toast.fail('Failed to send');
        console.log(error,'发送失败')
        /* 发送失败的处理逻辑 */
      });
      // let mode = {
      //   id: this.getUUId(),
      //   txt: this.con.replace(/ /g,"&nbsp;"),
      //   logo:
      //     "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=3516796069,1638897945&fm=15&gp=0.jpg",
      //   type: Math.random() >= 0.5 ? "from" : "me",
      // };
      // this.isBottom = true;
      // this.isTouch = false;
      // this.dataPush(mode);
      
    },
    async sendData(opt){
      let createAt=opt.createAt
      // addAgoraMessage
      // let msg=JSON.stringify({content:this.con});
      // let opt={
      //   publisherId:this.userId,
      //   exhibitorId:this.exhibitorId,
      //   userId:this.userId,
      //   messageType:'text',
      //   message:msg
      // }
      delete opt.createAt;
      let res=await this.addAgoraMessage(opt);
      if(res&&res.result){
        let mode=JSON.parse(JSON.stringify(opt));
        mode.message=JSON.parse(mode.message);
        mode.createdAt=createAt;
        mode.isUser=true;
        this.dataPush(mode)
        //发送成功
      }else{
        this.$toast.fail('Failed to send');
      };
      this.con='';
    },
    getUUId() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },
    initSwiper() {
      this.scroll = new Bscroll(this.$refs.chat, {
        scrollY: true,
        click: true,
        probeType: 3,
        mouseWheel: true,
        pullDownRefresh:true,
        bounce: {
          top: true,
          bottom: true,
        },
        scrollbar: {
          fade: true,
        },
      });
      let that = this;
      //用户轻抚
      this.scroll.on("flick", () => {
        let barAllH = $(".chat_wrap").height();
        let wrapH = $(".chat").height();
        if (barAllH > wrapH) {
          that.isTouch = true;
        }
      });
      this.scroll.on("pullingDown",()=>{
        console.log('下拉触发',that.finished)
        if(that.finished){
          that.scroll.finishPullDown()
        }else{
          that.pageIndex+=1;
          that.loading=true;
          that.getMssage();
        }
      })
      //滚动中
      this.scroll.on("scroll", (obj) => {
        // if($('.barrage .bscroll-vertical-scrollbar .bscroll-indicator')){
        //    $('.barrage .bscroll-vertical-scrollbar .bscroll-indicator').addClass('scrollstyle');//
        // }
        let barAllH = $(".chat_wrap").height();
        let chatH = $(".chat").height();
        // console.log(barAllH,chatH)
        // console.log(barAllH - chatH,Math.abs(obj.y),'滚动中haodu')  // + 25
        if (barAllH - chatH <= Math.abs(obj.y) + 30) {
          that.isBottom = true;
          that.isTouch = false;
          if (that.newBarrageList.length) {
            that.getNewBarrage();
            // that.dataPush(model);
            // }
          }
        } else if (barAllH - chatH > 0) {
          that.isBottom = false;
        }
      });
    },
    setRead(){
      let opt={
        exhibitorId:this.exhibitorId,
        userId:this.userId
      }
      this.readExhibitorMsg(opt);
      // console.log('stateRes',stateRes)
    },
    //设置滚动条滚动至底
    setScrollTop() {
      let Lis = $(".chat_item"); // 查找所有bar_block元素
      this.scroll.refresh();
      this.scroll.scrollToElement(Lis[Lis.length - 1], 300); // 滑动到指定元素,设置动画300ms
    },
    //数据获取
    dataPush(data) {
      let min=0;
      if(this.barrageList.length){
        if(this.barrageList[this.barrageList.length-1].messageType=='roomClose'||data.messageType=='roomClose'){
          min=0
        }else{
          min=Math.abs(moment(data.createAt).diff(this.barrageList[this.barrageList.length-1].createAt,'minute'));
        }
      }else{
        min=10;
      }
      if(min>=10){
        data.timeStr=dateString.getDataString(moment(data.createAt).format('x'),true)
        let mode={
          timeText:data.timeStr,
          messageType:'time',
          id:this.getUUId()
        }
        this.barrageList.push(mode)
      }
      this.barrageList.push(data);
      this.$nextTick(()=>{
        this.scroll.finishPullDown();
      })
      if (this.isBottom && !this.isTouch) {
        //
        // if(this.barrageList.length>20){    dom多了处理
        //    this.stortBarrageList.push(this.barrageList.shift());
        // }
        this.$nextTick(() => {
          this.setScrollTop();
        });
      } else {
        // this.newBarrageList.push(data);
        this.$set(this.newBarrageList, this.newBarrageList.length, data);
      }
      //
    },
    //读取新消息
    getNewBarrage() {
      this.newBarrageList = [];
      this.isBottom = true;
      this.$nextTick(() => {
        this.setScrollTop();
      });
    },
  },
};
</script> 

<style lang="scss" scoped>
.chat-talk {
  background: #e5e5e5;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .my-flag-icon{
    &.logo{
      margin-right: 0;
    }
  }
  .chat {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100% - 1rem);
    transition: all 0.3s;
    overflow-y: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    z-index: 8;
    .chat_wrap {
      padding: 0 0.3rem;
      // min-height: 100%;
      &::after {
        content: "";
        display: block;
        width: 100%;
        height: 0.3rem;
      }
      .chat_item {
        display: flex;
        width: 100%;
        //消息
        .logo {
          width: 0.8rem;  
          height: 0.8rem;
          display: block;
          border-radius: 50%;
        }
        .txt {
          min-height: 0.8rem;
          display: flex;
          align-items: center;
          font-size: 0.3rem;
          max-width: 4.85rem;
          border-radius: 0.2rem;
          padding: 0.15rem 0.25rem;
          position: relative;
          &.room_info {
            width: 4.85rem;
            padding: 0.16rem 0.2rem 0.16rem 0.16rem;
            align-items: initial;
            img {
              width: 1.3rem;
              height: 1.3rem;
              border-radius: 0.05rem;
              margin-right: 0.2rem;
              flex-shrink: 0;
              display: block;
            }
            .comp_info {
              display: flex;
              flex-direction: column;
              justify-content: center;
              width: calc(100% - 1.5rem);
              .info_title {
                color: #333;
                font-size: 0.3rem;
              }
              .info_txt {
                margin-top: 0.13rem;
                color: #666;
                font-size: 0.22rem;
              }
            }
          }
          &::after {
            content: "";
            display: block;
            position: absolute;
            top: 0.26rem;
            border-top: 0.14rem solid transparent;
            border-bottom: 0.14rem solid transparent;
          }
        }
        .user {
          .txt {
            background: #1890ff;
            color: #fff;
            box-shadow: 0 0.05rem 0.2rem 0 rgba(91, 139, 237, 0.1);
          }
        }
        .service {
          .txt {
            background: #fff;
            color: #333;
            box-shadow: 0 0.05rem 0.2rem 0 rgba(0, 49, 103, 0.1);
          }
        }
        .txt_left,
        .txt_right {
          margin-top: 0.3rem;
          &.room {
            margin-top: 0.5rem;
          }
        }
        .txt_left {
          display: flex;
          .logo {
            margin-right: 0.22rem;
          }
          &.user {
            .txt {
              &::after {
                border-right: 0.14rem solid #1890ff;
                left: -0.12rem;
              }
            }
          }
          &.service {
            .txt {
              &::after {
                border-right: 0.14rem solid #fff;
                left: -0.12rem;
              }
            }
          }
        }
        .txt_right {
          margin-left: auto;
          display: flex;
          .logo {
            margin-left: 0.22rem;
          }
          &.user {
            .txt {
              &::after {
                border-left: 0.14rem solid #1890ff;
                right: -0.12rem;
              }
            }
          }
          &.service {
            .txt {
              &::after {
                border-left: 0.14rem solid #fff;
                right: -0.12rem;
              }
            }
          }
        }
        //时间
        .time {
          display: flex;
          margin: 0.5rem auto 0;
          align-items: center;
          height: 0.4rem;
          padding: 0 0.17rem;
          background: #dadada;
          border-radius: 1px;
          color: #fff;
          font-size: 0.22rem;
        }
        .video_apply {
          display: flex;
          margin: 0.5rem auto 0;
          align-items: center;
          height: 0.74rem;
          padding: 0 0.5rem;
          background: #fff;
          box-shadow: 0 0.05rem 0.1rem 0 rgba(91, 139, 237, 0.1);
          border-radius: 0.05rem;
          p {
            color: #666;
            span {
              margin-left: 0.1rem;
              color: #1890ff;
            }
          }
        }
      }
    }
  }
  .chat_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1rem;
    width: 100%;
    background: #f2f2f2;
    z-index: 9;
    display: flex;
    padding: 0.17rem 0.3rem;
    justify-content: space-between;
    .newBarrage {
     position: absolute;
     right: .3rem;
     top: -0.75rem;
     i{
       font-size: 0.6rem;
       color: #1890ff;
       position: relative;
       span{
         color: #fff;
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%,-50%);
       }
     }
    }
    .video_conn {
      width: 2.2rem;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1890ff;
      border-radius: 999px;
      background: #e7f4ff;
      border: 1px solid #1890ff;
      &.v_conn_close{
        border: none;
        background: #bfbfbf;
        color: #fff;
      }
      span {
        font-size: 0.24rem;
      }
      i {
        font-size: 0.5rem;
        margin-right: 0.05rem;
      }
    }
    .input_con {
      width: 4.4rem;
      padding: 0 0.3rem;
      border-radius: 999px;
      background: #fff;
      display: flex;
      align-items: center;
      // input {
      //   width: 100%;
      //   border: none;
      // }
      .input_focus{
        line-height: inherit;
        padding-left:0 ;
        padding-right:0 ;
        background: #fff;
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  // opacity: ;
  // overflow: hidden;
  // transition: height .3s;
  // &.open{
    
  // }
  // position: absolute;
  // width: 100%;
  // top: 0;
  // left: 0;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
